/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * TopTopTime API
 * <:3 )~~~~    =^.^=
 * OpenAPI spec version: 0.0.1
 */

/**
 * For online bookings: how the meeting room is sourced. Resolved from the delivery snapshot when the link was delivered, else from the activity's online config - so a pending 'manual' booking is recognizable before its link exists.
 */
export enum BookingResponseAllOfMeetingProvider {
  toptoptime = 'toptoptime',
  byo = 'byo',
  manual = 'manual'
}
